<template>
   <div class="tree" v-if="data&&data.length>0&&userInfo.isShowFlow==1">
      <el-card class="box-card" body-style="padding:10px;border:1px solid #E4E7ED">
         <processTree :data="data" @clickitem="clickitem"></processTree>
      </el-card>
   </div>
</template>

<script>
import processTree from './processTree.vue'
export default {
   props: ['orderId'],
   components: { processTree },
   name: "tree",
   data() {
      return {
         data: [],
         userInfo: "",
      }
   },

   methods: {
      clickitem(val) {
         console.log(val);
         if (val.businessId) {
            // this.$parent.$parent.$parent.toDetail(val.orderId);
            this.$parent.$parent.$parent.$parent.toDetail(val.businessId);
         }
      },
      async init(orderId) {
         if (sessionStorage.getItem('userInfo')) {
            this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            if (this.userInfo.isShowFlow==1) {//判断是否展示流程图
                const res = await this.$http.penetrateAllInfo({ ids: [orderId] })
                this.data = res.result
            }
         }
      },
   },
   updated() {
      this.$emit('tabHeight', this.$common.getHeight())
   },
}
</script>

<style scoped></style>